

















































































































































































































































import {
  Vue,
  servicesURL,
  headers,
  analyticsEvents,
  mixpanelEvents,
} from "../../constants/constants";
import { staticContent } from "../../localisation/detect-lang";
import axios from "axios";
import * as moment from "moment";
import itemModalTemplate from "./item-view-modal.vue";
import menuItem from "./menu-items.vue";
import { pushAnalyticsEvent, pushMixpanelEvent } from "../../helpers";
import * as _ from "lodash";
import RestaurantScripts from "../restaurant-scripts/RestaurantScripts.vue";

export default Vue.extend({
  components: {
    "item-modal-template": itemModalTemplate,
    "menu-item": menuItem,
    "restaurant-scripts": RestaurantScripts
  },
  data() {
    return {
      appName: 'restaurant-menus',
      staticContent,
      likedItems: {},
      searchKeyword: "",
      menu: null,
      searchTime: null,
      showSearchInput: false,
      showLoading: false,
    };
  },
  computed: {
    URLBuilder() {
      return this.$root.URLBuilder;
    },
    isMobile() {
      return this.$root.isMobile;
    },
    shouldIstickToBottom() {
      return this.$root.shouldIstickToBottom;
    },
    shouldIStick() {
      return this.$root.shouldIStick;
    },
    moment() {
      return moment;
    },
    utcOffset() {
      return moment().utcOffset();
    },
    bindConditionalClasses() {
      return this.$root.bindConditionalClasses;
    },
    loading() {
      return this.$store.state.menuLoading;
    },
    branchMenus() {
      return this.$store.state.branchMenus;
    },
    userCityName() {
      return this.$root.userCityName;
    },
    flatCategories() {
      const menu = this.$store.state.branchMenus;
      let allCategories = menu.categories;

      let newCategoryList = allCategories.map((category) => {
        category.ref = {
          menu: {
            availability: {
              timeAvailability: {
                availabilityFromTime: menu.availability.timeAvailability.availabilityFromTime,
                availabilityToTime: menu.availability.timeAvailability.availabilityToTime,
                availableNow: menu.availability.timeAvailability.availableNow
              },
              availableForDelivery: menu.availability.availableForDelivery,
            },

            name: menu.name,
            uuid: menu.uuid,
          },
        };
        return category;
      });
      return newCategoryList;
    },
    flatItems() {
      return this.flatCategories
        .reduce((allItems, category) => {
          let newItemsArray = category.items.map((item) => {
            item.category = {

              availability: {
                timeAvailability: {
                  availabilityFromTime: category.availability.timeAvailability.availabilityFromTime,
                  availabilityToTime: category.availability.timeAvailability.availabilityToTime,
                  availableNow: category.availability.timeAvailability.availableNow
                },
                availableForDelivery: category.availability.availableForDelivery,
              },
              type: category.type,
              description: category.description || '',
              name: category.name,
              uuid: category.uuid,

            };
            item.menu = category.ref.menu;
            return item;
          });
          allItems = allItems.concat(newItemsArray);
          return allItems;
        }, [])
        .reduce((itemsObj, item) => {
          itemsObj[item.uuid] = {
            ...item,
            category: item.category,
            menu: item.menu,
            uuid: item.uuid,
          };
          return itemsObj;
        }, {});
    },
    user() {
      return this.$root.user;
    },
    restaurantInfo() {
      return this.$root.restaurantPage.restHeaderObj;
    },
  },

  created() {
    this.$store
      .dispatch("GET_BRANCH_MENU", [
        this.restaurantInfo.branchShortCode,
        this.user.company ? this.user.company.place_id : null,
      ])
      .then((res) => {
        this.menu = res;
        let urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("item")) {
          let itemUUID = urlParams.get("item").split(" ").pop();
          this.openItemDetails(itemUUID);
        }
      });
  },
  methods: {
    openItemDetails(itemUUID) {
      let item = this.flatItems[itemUUID];
      const availability = item.availability.availableInCurrentMenu && item.availability.availableInBranch && item.availability.availableForDelivery && item.availability.timeAvailability.availableNow;
      const utcOffset= moment().utcOffset();
      if (item) {
        this.itemModalClick(
          item.category.uuid,
          itemUUID,
          item.name,
          availability,
          item.availability.timeAvailability.availableNow,
          moment(item.menu.availability.timeAvailability.availableFromTime).add(utcOffset,'m').format("HH:mm"),
          moment(item.menu.availability.timeAvailability.availableToTime).add(utcOffset,'m').format("HH:mm"),
          this.formatTime(item.availability.timeAvailability.availabilityFromTime),
          this.formatTime(item.availability.timeAvailability.availabilityToTime),
          this.restaurantInfo.orderingEnabled &&
          this.restaurantInfo.branchOrderingEnabled
        );
        this.modalToggler("item-view-modal", "show");
      }
    },
    modalToggler(menuId, method) {
      return this.$root.modalToggler(menuId, method);
    },
    menuToggler(menuId) {
      this.$root.shouldIStick = false;
      if (!this.bindConditionalClasses.some((item) => item == menuId)) {
        this.modalToggler(menuId, "show");
        let openMenu = this.bindConditionalClasses.findIndex((item) =>
          item.includes("rest-menu")
        );
        openMenu > -1 && this.$root.bindConditionalClasses.splice(openMenu, 1);
      }
    },
    isMenuAvailable(openingTime: string, closingTime: string) {
      return openingTime
        ? this.isWithinTimeFrame(openingTime, closingTime)
        : true;
    },
    formatTime(timeParam) {
      return timeParam
        ? moment(timeParam,"hh:mm:ss").add(moment().utcOffset(),'m').format('HH:mm')
        : "";
    },
    isWithinTimeFrame(openingTime: string, closingTime: string) {
      let openDateObject = moment(openingTime, "HH:mm:ss");
      let closeDateObject =
        closingTime < openingTime
          ? moment(closingTime, "HH:mm:ss").add(1, "days")
          : moment(closingTime, "HH:mm:ss");

      return moment().isBetween(
        openDateObject,
        closeDateObject,
        undefined,
        "[]"
      );
    },

    isItemLiked(itemUUID) {
      return !this.likedItems[itemUUID]
        ? (this.flatItems[itemUUID] && this.flatItems[itemUUID].isLikedByUser)
        : this.likedItems[itemUUID].isLikedByUser;
    },
    getItemLikes(itemUUID) {
      return !this.likedItems[itemUUID]
        ? this.flatItems[itemUUID].likesCount
        : this.likedItems[itemUUID].likesCount;
    },
    addLikes(itemUUID, method) {
      axios({
        method: method,
        url: servicesURL.restaurant.item.like(itemUUID),
        headers,
      })
        .then((res) => console.log("res", res))
        .catch((error) => console.log("error", error));
    },
    itemLikeHandler(liked: boolean, itemUUID: string, initialLikes: number) {
      if (this.likedItems[itemUUID]) {
        this.likedItems[itemUUID] = {
          itemUUID,
          isLikedByUser: !liked,
          likesCount: liked ? initialLikes - 1 : initialLikes + 1,
        };
      } else {
        this.$set(this.likedItems, itemUUID, {
          itemUUID,
          isLikedByUser: !liked,
          likesCount: liked ? initialLikes - 1 : initialLikes + 1,
        });
      }

      let method: string = liked ? "DELETE" : "POST";
      this.addLikes(itemUUID, method);
    },
    async itemModalClick(
      catUUID,
      uuid,
      name,
      menuAvailableOnTime = true,
      availableOnTime = true,
      menuFromTime = "",
      menuToTime = "",
      fromTime = "",
      toTime = "",
      menuAvailableForOnlineOrering = true
    ) {
      this.$root.itemModal = {
        flatExtraCategories: {},
        isExCatsValid: true,
        itemSubTotal: 0,
        itemData: null
      };
      if (this.searchKeyword) {
        pushAnalyticsEvent(
          analyticsEvents.restaurant.category,
          analyticsEvents.restaurant.events.searchedItem,
          analyticsEvents.restaurant.labels.selectedItem(name)
        );
      }

      this.$store.state.startGroup = false;
      pushMixpanelEvent(
        mixpanelEvents.openItemDetails.event,
        mixpanelEvents.openItemDetails.properties(
          this.restaurantInfo.name ? this.restaurantInfo.name : "N/A",
          this.$root.flatAreas[this.$root.deliveryStatus.areaUUID]
            ? this.$root.flatAreas[this.$root.deliveryStatus.areaUUID].name
            : "N/A",
          this.$root.orderingEnabled ? "Yes" : "No"
        )
      );
      window["gtag"]("event", "view_item");
      pushAnalyticsEvent(
        analyticsEvents.restaurant.category,
        analyticsEvents.restaurant.events.open_item_details,
        analyticsEvents.restaurant.labels.enabledState(
          this.restaurantInfo.orderingEnabled &&
            this.restaurantInfo.branchOrderingEnabled
        )
      );

      try {
        let item = this.flatItems[uuid];
        if (!this.flatItems[uuid].extraCategories) {
          const res = await axios({
            method: "GET",
            url: servicesURL.restaurant.item.getDetails(this.restaurantInfo.branchShortCode, uuid),
            headers,
          });

          item = { ...this.flatItems[uuid], ...res.data };
          this.flatItems[uuid] = item;
        }
        this.$root.itemModal.itemData = Object.assign(
          {
            ...item,
            quantity: 1,
            selectedSizeUUID: item.sizes[0].itemSizeUUID,
            comment: "",
            menuAvailableOnTime: menuAvailableOnTime,
            availableOnTime: availableOnTime,
            menuFromTime,
            menuToTime,
            fromTime,
            toTime,
            catUuid: catUUID,
            menuAvailableForOnlineOrering: menuAvailableForOnlineOrering,
          },
          this.flatItems[uuid]
        );

        this.$root.sizes = item.sizes.reduce((sizeObj, size) => {
          sizeObj[size.itemSizeUUID] = Object.assign({}, size, {
            itemUUID: item.uuid,
            itemName: item.name,
            uuid: size.itemSizeUUID,
            sizeUUID: size.sizeUUID,
            name: size.sizeName,
          });
          return sizeObj;
        }, {});

        this.$root.itemModal.itemSubTotal =
          this.$root.sizes[this.$root.itemModal.itemData.selectedSizeUUID].price * this.$root.itemModal.itemData.quantity;

        !item.extraCategories.length &&
          (this.$root.itemModal.isExCatsValid = true);
        this.$root.itemModal.flatExtraCategories = item.extraCategories.reduce((exCatsObj, exCat) => {
          exCat.minimumAllowedExtra &&
            (this.$root.itemModal.isExCatsValid = false);
          exCatsObj[exCat.uuid] = {
            sizeRestricted: exCat.sizeRestricted,
            isValid: exCat.minimumAllowedExtra ? false : true,
            minimumAllowedExtra: exCat.minimumAllowedExtra,
            maximumAllowedExtra: exCat.maximumAllowedExtra,
            flatSizes: exCat.items.reduce((itemsObj, item) => {
              itemsObj = Object.assign(
                {},
                itemsObj,
                item.sizes.reduce((sizeObj, size) => {
                  sizeObj[size.itemSizeUUID] = Object.assign({}, size, {
                    itemUUID: item.uuid,
                    itemName: item.name,
                    uuid: size.itemSizeUUID,
                    sizeUUID: size.sizeUUID,
                    name: size.sizeName,
                  });
                  return sizeObj;
                }, {})
              );
              return itemsObj;
            }, {}),
            selectedItems: [],
          };
          return exCatsObj;
        }, {});
        this.$nextTick(() => {
          this.$root.itemSizeChangeHandler();
        });

        const params = new URLSearchParams(window.location.search);
        params.set("item", item.name + " " + uuid);
        window.history.replaceState(
          {},
          "",
          decodeURIComponent(`${window.location.pathname}?${params}`)
        );
      } catch (err) {
        console.log(err)
      }

    },
    clearSearchInterval() {
      clearTimeout(this.searchTime);
    },
    handleSearch(e) {
      var regex = /[a-zA-Z\u0621-\u064A0-9 ]$/;
      this.showLoading = true;
      //run function when click charater or number or delete or space
      if (regex.test(this.searchKeyword) || e.keyCode == 8) {
        this.clearSearchInterval()
        this.scrollToTop()
        this.searchTime = setTimeout(() => {
          this.handleMenusData();
        }, 700);
      } else {
        this.menu = {
          categories: [],
          itemsWithDiscounts: [],
          mostLikedItems: [],
          noResult: true,
          ...this.menu
        }
        this.showLoading = false;
      }
    },
    handleMenusData() {
      pushAnalyticsEvent(
        analyticsEvents.restaurant.category,
        analyticsEvents.restaurant.events.searchMenu,
        analyticsEvents.restaurant.labels.keyword(this.searchKeyword)
      );

      let newMenu = JSON.parse(JSON.stringify(this.branchMenus));
      let searchKeyword = this.searchKeyword.trim().toLowerCase();


      // offers
      if (newMenu.itemsWithDiscounts && newMenu.itemsWithDiscounts.length > 0) {
        let offers = [];
        if (staticContent.restaurant.menuTab.offers.toLowerCase().indexOf(searchKeyword) != -1) {
          offers = newMenu.itemsWithDiscounts;
        } else {
          newMenu.itemsWithDiscounts.forEach((dish) => {
            if (dish.name.toLowerCase().includes(searchKeyword)) {
              offers.push(dish)
            }
          });
        }
        newMenu.itemsWithDiscounts = offers;
      }

      // top dishes
      if (newMenu.mostLikedItems && newMenu.mostLikedItems.length > 0) {
        let topDishes = [];
        if (staticContent.restaurant.menuTab.topDishes.toLowerCase().indexOf(searchKeyword) != -1) {
          topDishes = newMenu.mostLikedItems;
        } else {
          newMenu.mostLikedItems.forEach((dish) => {
            if (dish.name.toLowerCase().includes(searchKeyword)) {
              topDishes.push(dish)
            }
          });
        }
        newMenu.mostLikedItems = topDishes;
      }

      // categories
      let categories = []
      newMenu.categories.forEach((category) => {
        if (category.name.toLowerCase().indexOf(searchKeyword) != -1) {
          categories.push(category);
        } else {
          let categoryItem = category.items.filter(
            (item) =>
              item.name.toLowerCase().indexOf(searchKeyword) != -1
          );
          if (categoryItem.length > 0) {
            category.items = categoryItem;
            categories.push(category)
          }
        }
      });


      newMenu.categories = categories.filter((cat) => cat);
      if (
        !newMenu.categories.length &&
        !newMenu.mostLikedItems.length &&
        !newMenu.itemsWithDiscounts.length
      ) {
        newMenu.noResult = true;
      }


      this.menu = newMenu;
      this.showLoading = false;
    },
    handleToggleSearchInput() {
      this.toggleSearchInput();
      this.scrollToTop()
      this.clearMenuSearch();
    },
    toggleSearchInput() {
      this.showSearchInput = !this.showSearchInput;
    },
    scrollToTop() {
      let myElement = document.getElementById("restaurant-tabs-nav");

      if (myElement) {
        if (!this.isMobile || (this.isMobile && this.showSearchInput)) {
          myElement.scrollIntoView({ behavior: "smooth" });
        }
      }
    },
    clearMenuSearch() {
      this.searchKeyword = "";
      this.showLoading = false;
      this.menu = JSON.parse(JSON.stringify(this.branchMenus));
    },
  },
});
